import { deleteItem, getItem, setItem } from '../utils/storage'

const PENDING_SIGNUP_FIRST_NAME_KEY = 'firstName'

export async function setPendingSignupFirstName(firstName: string) {
  await setItem(PENDING_SIGNUP_FIRST_NAME_KEY, firstName.trim(), {
    scoped: false,
  })
}

export async function getPendingSignupFirstName() {
  const value = await getItem(PENDING_SIGNUP_FIRST_NAME_KEY, {
    scoped: false,
  })
  const trimmed = value?.trim()

  return trimmed != null && trimmed.length > 0 ? trimmed : null
}

export async function clearPendingSignupState() {
  await deleteItem(PENDING_SIGNUP_FIRST_NAME_KEY, {
    scoped: false,
  })
}
